import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import imageOne from '../resource/dana/F12 (2).png'
import imageOtwo from '../resource/dana/F12.png'
import imageThree from '../resource/dana/F13.png'
import imageFour from '../resource/dana/L14.png'
import imageFive from '../resource/dana/L15.png'
import imageSix from '../resource/dana/L18.png'
import imageSeven from '../resource/dana/L16.png'
import imageEight from '../resource/dana/L17.png'
import imageNine from '../resource/dana/F11.png'

import imageTen from '../resource/dana/10 xxx.png';

import TitleChnage from "../Hook/TitleChnage";

import '../css/common.css'

const Dana = () => {

    TitleChnage("Dana Page")


        const navigate = useNavigate();

        const [isTextVisible,setIsTextVisible] = useState(false);

        const handleToggle = () => {
            setIsTextVisible((prev) => !prev);
        }

        const handleClick = (event) => {

            const pathMap = {
                danaCalander: '/danaCalander',
                paymentfordana: '/paymentfordana',
                pirikara: '/pirikara',
                gilanpasa:'/gilanpasa',
                danaInstructions:'/danaInstructions',
                pindapatha:'/pindapatha'
            }

            const path = event.currentTarget.id;
            const targetPath = pathMap[path]

            if (targetPath) {
                navigate(targetPath)
            }
        }
    

    return (
        <div className="page bana-page">
            <img src={imageOne} alt="" className="left-imge" />
            <img src={imageOtwo} alt="" className="right-imge" />



            <header>
                <div className="home-icon">
                    {/* <img src="#" alt="Home Icon"> */}
                </div>
                <div className="title">
                    <h1>Dana</h1>
                    <img src={imageThree} width={200} />
                </div>
            </header>

            <section className="intro-text">
                <p className="text-bold">May your kindness and generosity be a spring of joy!</p>
                <p className="text-bold">May we all live free from hunger -in harmony, safety and peace!</p>

                <br />

                <p className="dana-info text-black">As in the time Budda, the Sangha wholly depend on the kindness and
                     generosity of the lay community for daily requisites including food, shelter, clothing, and medicines.
                    <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "" : "more"}</span></p>

                {isTextVisible &&
                <div className="hidden-text">
                    <p className="dana-info text-black">  The stream of generosity of donors offering breakfast and lunch   Dana gives the Sangha the strenght to continue
                       their practice bringing the encouragement and joy.</p>
                <p className="dana-info text-black">Following the ancient Buddhist monastic regulations Sangha finish their meal by midday then please follow the instructions to offer the food Dana on time.</p>
                <p className="dana-info text-black">Lay devotees are welcome to bring meal Dana to offer to the Sangha and to share with other lay visitors in the morning and the afternoon.</p>
                <p className="dana-info text-black">Breakfast Dana offerings to the Sangha take place at 6:30 am.</p>
                <p className="dana-info text-black">Lunch Dana offerings to the Sangha take place at 11:00 am.</p>
                <p className="dana-info text-black">The Breakfast and Lunch Dana rosters are maintained to ensure that at least one community member is available to offer food.</p>
                <p className="dana-info text-black">Please note, if there is a difficulty of offering a ready-to-eat meal, money can be donated to deliver the meals to the Monastery. </p>
                <p className="dana-info text-black">To book a date, please go through the following Dana Calendar <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "less" : ""}</span></p>


                </div>
                }
            </section>

            <section className="button-section">
                <div className="left-col">
                    <img src={imageFour} alt="" width={250} id="danaCalander" onClick={handleClick} />
                    <img src={imageEight} alt="" width={250} id="danaInstructions" onClick={handleClick}/>
                </div>
                <div className="left-col">
                    <img src={imageTen} alt="" width={200} id="gilanpasa" onClick={handleClick}/>
                    <img src={imageSix} alt="" width={200} id="pirikara" onClick={handleClick}/>



                </div>
                <div className="right-col">
                    <img src={imageSeven} alt="" width={250} id="pindapatha" onClick={handleClick} />
                    <img src={imageFive} alt="" width={250} id="paymentfordana" onClick={handleClick}/>

                </div>
            </section>

            <div className="box">
                <img src={imageNine} alt="" className="bottom-imge" />
            </div>
        </div>
    )
}


export default Dana